var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form__lang"},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onSwitchClick('en')}}},[_vm._v("English")]),_vm._v(" | "),_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onSwitchClick('de')}}},[_vm._v("Deutsch")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ac5be8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/HeaderLangSelector.vue
// module id = 89
// module chunks = 0